import { render, staticRenderFns } from "./SurveyQR.vue?vue&type=template&id=5968ebec&scoped=true"
import script from "./SurveyQR.vue?vue&type=script&lang=js"
export * from "./SurveyQR.vue?vue&type=script&lang=js"
import style0 from "./SurveyQR.vue?vue&type=style&index=0&id=5968ebec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5968ebec",
  null
  
)

export default component.exports